module.exports = __webpack_public_path__ + "img/list6.d6aaa612.png";